module.exports = __webpack_public_path__ + "static/media/home.0dcf3a7f.svg";